import { eDisbursementType } from 'types/order/escrow/eDisbursementType';
import { ACHDisbursementType } from './ach/ACHDisbursementType';
import { CheckDisbursementType } from './checks/CheckDisbursementType';
import { WireDisbursementType } from './wires/WireDisbursementType';
import { InternalTransferDisbursementType } from './internalTransfers/InternalTransferDisbursementType';

export const disbursementByType = {
  [eDisbursementType.ACH]: ACHDisbursementType,
  [eDisbursementType.Check]: CheckDisbursementType,
  [eDisbursementType.Wire]: WireDisbursementType,
  [eDisbursementType.InternalTransfer]: InternalTransferDisbursementType,
};
